import { TeamDataObject } from "../DataStorage/TeamDataObject";

export class BuilderProjectMembership extends TeamDataObject {
    emailAddress: string;
    projectId: string;
    isAdmin: boolean = false;

    constructor(emailAddress: string, projectId: string) {
        super();
        this.emailAddress = emailAddress;
        this.projectId = projectId;
    }
}
